// extracted by mini-css-extract-plugin
export default {"form":"Partner_form__B0OI6","submit":"Partner_submit__VNkgE"};